import React, { useEffect, useState } from 'react'
import Button from '@mui/material/Button'
import LoadingButton from '@mui/lab/LoadingButton'
import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import CircularProgress from '@mui/material/CircularProgress'
import Snackbar from '@mui/material/Snackbar'
import Alert from '@mui/material/Alert'
import Tooltip from '@mui/material/Tooltip'
import FileUploadIcon from '@mui/icons-material/FileUpload'
import IconButton from '@mui/material/IconButton'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import DownloadIcon from '@mui/icons-material/Download'
import Star from '@mui/icons-material/Star'
import StarBorder from '@mui/icons-material/StarBorder'
import AutoAwesome from '@mui/icons-material/AutoAwesome'

import ContenutoScheda from './ContenutoScheda'
import BottoniScheda from './BottoniScheda'
import upload from '../../api/upload'
import altTextApi from '../../api/altText'

function SceltaImmagini({
  selezionata,
  cambiaSelezionata,
  immagini,
  creaImmagine,
  eliminaImmagine,
  aggiornaImmagine,
  aggiornaImportanzaImmagini,
  isModifica,
  confermaModifiche,
}) {
  const numero = 5 //quante immagini per riga
  const [lista, setLista] = useState([])
  const [agg, setAgg] = useState(false)
  const [openAlert, setOpenAlert] = useState(0)
  const [successToast, setSuccessToast] = useState(null)
  const [errore, setErrore] = useState()
  const [loading, setLoading] = useState(false)
  const [titolo, setTitolo] = useState({
    italiano: '',
    inglese: '',
    tedesco: '',
    olandese: '',
    danese: '',
    polacco: '',
  })
  const [lingua, setLingua] = useState(1) //1 italiano, ...
  const [hoveredImageId, setHoveredImageId] = useState(null)
  const [localFavouriteUpdates, setLocalFavouriteUpdates] = useState({}) // Track local favourite updates
  const [localImageUpdates, setLocalImageUpdates] = useState({})
  const [draggedIndex, setDraggedIndex] = useState(null)
  const [dragOverIndex, setDragOverIndex] = useState(null)
  const [uploadLoading, setUploadLoading] = useState(false)
  const [generateAltOnUpload, setGenerateAltOnUpload] = useState(false)
  const [generatingImageId, setGeneratingImageId] = useState(null)
  const [favouriteLoadingImageId, setFavouriteLoadingImageId] = useState(null)

  const showSuccessToast = (message) => {
    setSuccessToast({ message, id: Date.now() })
  }

  const showError = (message) => {
    if (typeof message === 'string' && message.trim()) {
      setErrore(message)
      return
    }
    if (message && typeof message.message === 'string') {
      setErrore(message.message)
      return
    }
    setErrore('Si è verificato un errore.')
  }

  useEffect(() => {
    // Per flex-wrap, usiamo direttamente l'array immagini invece di dividerlo in righe
    // Apply local favourite updates to the immagini prop
    const updatedImmagini = immagini.map((img) => {
      let patched = { ...img }
      if (localFavouriteUpdates[img.id] !== undefined) {
        patched.favourite = localFavouriteUpdates[img.id]
      }
      if (localImageUpdates[img.id]) {
        patched = { ...patched, ...localImageUpdates[img.id] }
      }
      return patched
    })
    setLista(updatedImmagini)
  }, [agg, immagini, localFavouriteUpdates, localImageUpdates])

  const cambiaTitolo = (event) => {
    const data = event.target.value
    const appo = { ...titolo }
    if (lingua == 1) {
      appo.italiano = data
      return setTitolo(appo)
    } else if (lingua == 2) {
      appo.inglese = data
      return setTitolo(appo)
    } else if (lingua == 3) {
      appo.tedesco = data
      return setTitolo(appo)
    } else if (lingua == 4) {
      appo.olandese = data
      return setTitolo(appo)
    } else if (lingua == 5) {
      appo.danese = data
      return setTitolo(appo)
    } else if (lingua == 6) {
      appo.polacco = data
      return setTitolo(appo)
    }
  }

  const caricaImmagine = async (event) => {
    const file = event.target.files[0]
    if (!file) return
    if (file.type.split('/')[0] != 'image') return showError('Formato del file non valido. Richiesta Immagine.')
    setUploadLoading(true)
    try {
      let importanza = calcolaImportanzaMax()
      const uploaded = await creaImmagine(file, importanza, { generateAlt: generateAltOnUpload })
      if (uploaded?.id && generateAltOnUpload) {
        const results = await altTextApi.generateCoverAlt({ imageId: uploaded.id, overwrite: true })
        if (!results.ok) {
          showError(typeof results.data === 'string' ? results.data : 'Errore durante la generazione ALT.')
        } else if (!results.data?.skipped) {
          if (results.data?.immagine) {
            setLocalImageUpdates((prev) => ({ ...prev, [uploaded.id]: results.data.immagine }))
          }
          showSuccessToast('ALT copertina generato')
        }
      }
      setAgg(!agg)
    } finally {
      setUploadLoading(false)
    }
    event.target.value = ''
  }

  const confermaModificaImg = async () => {
    setLoading(true)
    await aggiornaImmagine(titolo)
    setTimeout(() => {
      cambiaSelezionata({ img: null, isModifica: false })
      setLoading(false)
      setLingua(1)
      //aggiorno la lista
      setAgg(!agg)
    }, 500)
  }

  const selezionaImmagine = (immagine) => {
    cambiaSelezionata({ img: immagine, isModifica: true })
    setTitolo({
      italiano: immagine.nome_italiano,
      inglese: immagine.nome_inglese,
      tedesco: immagine.nome_tedesco,
      olandese: immagine.nome_olandese,
      danese: immagine.nome_danese,
      polacco: immagine.nome_polacco,
    })
  }

  const annullaModificaImg = () => {
    setErrore()
    setLingua(1)
    cambiaSelezionata({ img: null, isModifica: false })
  }

  const confermaEliminaImmagine = async (img) => {
    await eliminaImmagine(img)
    //aggiorno la lista
    setAgg(!agg)
  }

  const chiudiAlert = (event, reason) => {
    if (reason === 'clickaway') return
    setErrore(null)
    setOpenAlert(0)
  }

  const chiudiSuccessToast = (event, reason) => {
    if (reason === 'clickaway') return
    setSuccessToast(null)
  }

  const copiaTitoloImmagine = (appoTitolo) => {
    setTitolo(appoTitolo)
    setOpenAlert(1)
  }

  const handleDragStart = (e, index) => {
    setDraggedIndex(index)
    e.dataTransfer.effectAllowed = 'move'
    e.dataTransfer.setData('text/html', index.toString())
  }

  const handleDragOver = (e, index) => {
    e.preventDefault()
    e.dataTransfer.dropEffect = 'move'
    if (draggedIndex !== null && draggedIndex !== index) {
      setDragOverIndex(index)
    }
  }

  const handleDragLeave = () => {
    setDragOverIndex(null)
  }

  const handleDrop = async (e, dropIndex) => {
    e.preventDefault()
    if (draggedIndex === null || draggedIndex === dropIndex) {
      setDraggedIndex(null)
      setDragOverIndex(null)
      return
    }

    const listCopy = Array.from(lista)
    const [removedElement] = listCopy.splice(draggedIndex, 1)
    listCopy.splice(dropIndex, 0, removedElement)
    setLista(listCopy)
    await startAggiornaImportanza(listCopy)
    if (confermaModifiche) await confermaModifiche()
    setDraggedIndex(null)
    setDragOverIndex(null)
  }

  const handleDragEnd = () => {
    setDraggedIndex(null)
    setDragOverIndex(null)
  }

  const startAggiornaImportanza = async (vett) => {
    const lista = []
    for (let i = 0; i < vett.length; i++) {
      lista.push(vett[i].id)
    }
    return aggiornaImportanzaImmagini(lista)
  }

  const removeFromList = (list, index) => {
    const result = Array.from(list)
    const [removed] = result.splice(index, 1)
    return [removed, result]
  }

  const addToList = (list, index, element) => {
    const result = Array.from(list)
    result.splice(index, 0, element)
    return result
  }

  const calcolaImportanzaMax = () => {
    let importanza = 0
    for (let i = 0; i < immagini.length; i++) {
      if (immagini[i].importanza >= importanza) importanza = immagini[i].importanza + 1
    }
    return importanza
  }

  const toggleFavourite = async (img, event) => {
    event.stopPropagation()
    const newFavouriteValue = !img.favourite
    setFavouriteLoadingImageId(img.id)

    // Helper function to get the current favourite state of an image
    const getCurrentFavouriteState = (image) => {
      if (localFavouriteUpdates[image.id] !== undefined) {
        return localFavouriteUpdates[image.id]
      }
      return image.favourite || false
    }

    try {
      let favouriteUpdated = false
    if (newFavouriteValue) {
      // Get all current favourites in the list, including local updates
      const allFavourites = immagini.filter((otherImg) => getCurrentFavouriteState(otherImg))

      // Optimistically update local state: set all favourites to false, then clicked one to true
      const optimisticUpdates = { ...localFavouriteUpdates }
      allFavourites.forEach((favouriteImg) => {
        optimisticUpdates[favouriteImg.id] = false
      })
      optimisticUpdates[img.id] = true
      setLocalFavouriteUpdates(optimisticUpdates)

      try {
        // First, unset all previously favourite images
        const unsetPromises = allFavourites.map(async (favouriteImg) => {
          let formData = new FormData()
          formData.append('id', favouriteImg.id)
          formData.append('favourite', 0)
          // Send API request to unset the favourite
          await upload.modificaImmagine(formData)
        })

        // Wait for all unset operations to complete
        await Promise.all(unsetPromises)

        // Now, set the new image to favourite
        let formData = new FormData()
        formData.append('id', img.id)
        formData.append('favourite', 1)

        const results = await upload.modificaImmagine(formData)
        if (!results.ok) {
          showError(results.data)
          // Revert optimistic update on error
          setLocalFavouriteUpdates((prev) => {
            const updated = { ...prev }
            delete updated[img.id]
            allFavourites.forEach((favouriteImg) => {
              delete updated[favouriteImg.id]
            })
            return updated
          })
          return
        }

        // Update with server response to ensure consistency
        if (results.data && results.data.favourite !== undefined) {
          setLocalFavouriteUpdates((prev) => ({
            ...prev,
            [img.id]: results.data.favourite,
          }))
        }
        favouriteUpdated = true
      } catch (error) {
        showError("Errore durante l'aggiornamento dei preferiti")
        // Revert optimistic update on error
        setLocalFavouriteUpdates((prev) => {
          const updated = { ...prev }
          delete updated[img.id]
          allFavourites.forEach((favouriteImg) => {
            delete updated[favouriteImg.id]
          })
          return updated
        })
      }
    } else {
      // If unsetting favourite, just update this one image
      let formData = new FormData()
      formData.append('id', img.id)
      formData.append('favourite', 0)

      // Optimistically update local state for instant UI feedback
      setLocalFavouriteUpdates((prev) => ({
        ...prev,
        [img.id]: false,
      }))

      // Call API to modify image
      const results = await upload.modificaImmagine(formData)
      if (!results.ok) {
        showError(results.data)
        // Revert optimistic update on error
        setLocalFavouriteUpdates((prev) => {
          const updated = { ...prev }
          delete updated[img.id]
          return updated
        })
        return
      }

      // Update with server response to ensure consistency
      if (results.data && results.data.favourite !== undefined) {
        setLocalFavouriteUpdates((prev) => ({
          ...prev,
          [img.id]: results.data.favourite,
        }))
      }
      favouriteUpdated = true
    }

    if (favouriteUpdated) {
      showSuccessToast(newFavouriteValue ? 'Immagine impostata come copertina' : 'Copertina rimossa')
    }

    // Refresh the list to trigger any UI changes
    setAgg(!agg)
    } finally {
      setFavouriteLoadingImageId(null)
    }
  }

  const generateCoverAlt = async (img, event) => {
    event.stopPropagation()
    setGeneratingImageId(img.id)
    try {
      const results = await altTextApi.generateCoverAlt({ imageId: img.id, overwrite: true })
      if (!results.ok) {
        showError(typeof results.data === 'string' ? results.data : 'Errore durante la generazione ALT copertina.')
        return
      }
      if (results.data?.skipped) {
        showError(results.data.reason || 'ALT già presente.')
        return
      }
      if (results.data?.immagine) {
        setLocalImageUpdates((prev) => ({ ...prev, [img.id]: results.data.immagine }))
      }
      showSuccessToast('ALT copertina generato')
      setAgg(!agg)
    } catch (error) {
      showError('Errore durante la generazione ALT copertina.')
    } finally {
      setGeneratingImageId(null)
    }
  }

  const imageActionButtonSx = {
    position: 'relative !important',
    top: '0 !important',
    left: '0 !important',
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    padding: '4px',
    margin: 0,
    minWidth: 'auto',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
  }

  const imageActionAnchorStyle = (top, left) => ({
    position: 'absolute',
    top,
    left,
    zIndex: 10,
    display: 'inline-flex',
    lineHeight: 0,
  })

  return (
    <React.Fragment>
      {!selezionata.isModifica && (
        <div className={isModifica ? 'admin-container-lungo' : 'admin-container'}>
          <h3 className="admin-titoletto">NUOVA IMMAGINE</h3>
          <Stack paddingTop={1}>
            <TextField
              id="raised-button-file"
              label="Immagine"
              variant="outlined"
              value=""
              onChange={async (event) => await caricaImmagine(event)}
              type="file"
              size={'small'}
              fullWidth
              autoComplete="off"
              style={{ display: 'none' }}
              disabled={uploadLoading}
            />
            <label className="admin-linea-bottone-immagine" htmlFor={uploadLoading ? undefined : 'raised-button-file'}>
              <LoadingButton
                loading={uploadLoading}
                disabled={uploadLoading}
                variant="contained"
                color="primary"
                component="span"
                startIcon={<FileUploadIcon />}
              >
                Upload
              </LoadingButton>
            </label>
            <FormControlLabel
              control={
                <Checkbox
                  checked={generateAltOnUpload}
                  onChange={(e) => setGenerateAltOnUpload(e.target.checked)}
                  disabled={uploadLoading}
                />
              }
              label="Genera ALT text al upload"
            />
          </Stack>
        </div>
      )}

      {!selezionata.isModifica && (
        <div className={isModifica ? 'admin-container-lungo' : 'admin-container'}>
          <h3 className="admin-titoletto">IMMAGINI</h3>
          {immagini.length == 0 && <span className="admin-titoletto">Nessuna Immagine presente.</span>}
          {immagini.length > 0 && (
            <div className="admin-lista-immagini-drag">
              {lista.map((img, index) => (
                <div
                  key={img.id}
                  draggable
                  onDragStart={(e) => handleDragStart(e, index)}
                  onDragOver={(e) => handleDragOver(e, index)}
                  onDragLeave={handleDragLeave}
                  onDrop={(e) => handleDrop(e, index)}
                  onDragEnd={handleDragEnd}
                  className={`admin-skill-immagine-container ${dragOverIndex === index ? 'drag-over' : ''} ${draggedIndex === index ? 'dragging' : ''}`}
                  onMouseEnter={() => setHoveredImageId(img.id)}
                  onMouseLeave={() => setHoveredImageId(null)}
                  style={{ cursor: 'move' }}
                >
                  <img
                    src={img.link}
                    alt={img.nome_italiano}
                    loading="lazy"
                    className="admin-skill-immagine-image"
                    draggable={false}
                  />
                  {(!!img.favourite || hoveredImageId === img.id || favouriteLoadingImageId === img.id) && (
                    <>
                      <Tooltip
                        title={img.favourite ? 'Rimuovi come copertina' : 'Imposta come copertina'}
                        placement="top"
                        arrow
                      >
                        <span style={imageActionAnchorStyle('5px', '5px')}>
                          <IconButton
                            className="admin-skill-immagine-star"
                            aria-label="toggle favourite"
                            onClick={(e) => toggleFavourite(img, e)}
                            onMouseDown={(e) => e.stopPropagation()}
                            disabled={favouriteLoadingImageId !== null}
                            size="small"
                            sx={imageActionButtonSx}
                          >
                            {favouriteLoadingImageId === img.id ? (
                              <CircularProgress size={22} sx={{ color: '#FFFFFF' }} />
                            ) : img.favourite ? (
                              <Star sx={{ color: '#FFD700', fontSize: '24px' }} />
                            ) : (
                              <StarBorder sx={{ color: '#FFFFFF', fontSize: '24px' }} />
                            )}
                          </IconButton>
                        </span>
                      </Tooltip>
                      {!!img.favourite && (
                        <Tooltip title="Genera ALT copertina" placement="top" arrow>
                          <span style={imageActionAnchorStyle('5px', '40px')}>
                            <IconButton
                              aria-label="genera ALT copertina"
                              onClick={(e) => generateCoverAlt(img, e)}
                              onMouseDown={(e) => e.stopPropagation()}
                              disabled={generatingImageId === img.id || favouriteLoadingImageId !== null}
                              size="small"
                              sx={imageActionButtonSx}
                            >
                              {generatingImageId === img.id ? (
                                <CircularProgress size={20} sx={{ color: '#FFFFFF' }} />
                              ) : (
                                <AutoAwesome sx={{ color: '#FFFFFF', fontSize: '22px' }} />
                              )}
                            </IconButton>
                          </span>
                        </Tooltip>
                      )}
                    </>
                  )}
                  <div className="admin-skill-immagine-overlay">
                    <span className="admin-skill-immagine-text">
                      {img.nome_italiano.length > 0 ? img.nome_italiano.substring(0, 29) : 'Senza Nome'}
                      <Stack direction="row" spacing={4}>
                        <IconButton
                          className="admin-bottone-skill-immagine"
                          color="nero"
                          aria-label="upload picture"
                          component="span"
                          onClick={() => selezionaImmagine(img)}
                          onMouseDown={(e) => e.stopPropagation()}
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          className="admin-bottone-skill-immagine"
                          color="nero"
                          aria-label="upload picture"
                          component="span"
                          onClick={async () => await confermaEliminaImmagine(img)}
                          onMouseDown={(e) => e.stopPropagation()}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Stack>
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {selezionata.isModifica && (
        <>
          <div className={isModifica ? 'admin-container-lungo' : 'admin-container'}>
            <Stack direction="row" alignItems="center" justifyContent="space-around">
              <Stack direction="column" spacing={1} alignItems="center" justifyContent="center">
                <h3 className="admin-titoletto">MODIFICA IMMAGINE</h3>
                <a className="admin-link-bottone-download" href={selezionata.img.link} download target="_blank">
                  <Button variant="contained" color="primary" component="span" startIcon={<DownloadIcon />}>
                    Download
                  </Button>
                </a>
              </Stack>
              <img className="admin-anteprima-img" src={selezionata.img.link}></img>
            </Stack>
          </div>
          <ContenutoScheda
            lingua={lingua}
            cambiaLingua={(v) => setLingua(v)}
            titolo={titolo}
            cambiaTitolo={cambiaTitolo}
            contenuto={null}
            cambiaContenuto={() => null}
            soloTitolo={true}
            copiaContenuti={copiaTitoloImmagine}
            isModifica={true}
          ></ContenutoScheda>
          <BottoniScheda loading={loading} conferma={confermaModificaImg} annulla={annullaModificaImg}></BottoniScheda>
        </>
      )}

      <Snackbar
        open={Boolean(errore)}
        onClose={chiudiAlert}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        sx={{ zIndex: 2000, top: 70 }}
      >
        <Alert onClose={chiudiAlert} variant="filled" severity="error" sx={{ width: '100%' }}>
          {errore}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openAlert == 1}
        onClose={chiudiAlert}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        sx={{ zIndex: 2000, top: 70 }}
      >
        <Alert onClose={chiudiAlert} variant="filled" severity="success" sx={{ width: '100%' }}>
          Titolo copiato nelle diverse lingue.
        </Alert>
      </Snackbar>
      <Snackbar
        key={successToast?.id}
        open={Boolean(successToast)}
        onClose={chiudiSuccessToast}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        sx={{ zIndex: 2000, top: 70 }}
      >
        <Alert onClose={chiudiSuccessToast} variant="filled" severity="success" sx={{ width: '100%' }}>
          {successToast?.message}
        </Alert>
      </Snackbar>
    </React.Fragment>
  )
}

export default SceltaImmagini
